const appApiUrl = window.location.hostname === 'localhost'
  ? 'http://localhost:3002'
  : '';

module.exports = { appApiUrl };
